/* Visar footern på sidan */
import React from "react";
const Header = () => {

    if (window.matchMedia('(display-mode: standalone)').matches) {
        return <></>
    }
    return (
        <a href='https://kjell.haxx.se/'>Till startsidan</a>
    )
}


export default Header;